import View from "ln/view/View";
import Signal from "ln/signal/Signal";
import { ISequence } from './SlideView';
import ListRenderer from "ln/list/ListRenderer";
import List from "ln/list/List";
import { ISlide } from './SlideDetailView';
import SlidePreview from './SlidePreview';
import { SlidePreviewCallback } from './SlidePreview';

class SlideSequence extends View {

    public slideview: ListRenderer<ISlide>;
    public selected:Signal<SlidePreviewCallback>;

    constructor( public data:ISequence, public courseversion:string, public startdate:string ){
        super( data );
        this.data.template = 'krw.slide-' + this.data.modelName.replace( 'App\\', '' ).toLocaleLowerCase().replace( 'preview', '').replace( 'slrg', '');
        this.selected = new Signal<SlidePreviewCallback>();

        // if we have slides - inject courseversion to slides
        if( this.data.slides ){
            this.data.slides.forEach( slide => {
                slide.courseversion = this.courseversion;
                slide.startdate = this.startdate;
            });
        }
    }

    protected init(){
        
        this.slideview = new ListRenderer<ISlide>( this.node.js( 'slides' ) );
        this.slideview.defaultRender( ( slide:ISlide ) => {
            var preview = new SlidePreview( slide ).render() as SlidePreview;
            preview.selected.add( this.onSelect, this );
            return { node: preview.node };

        });

        if( this.data.slides && this.data.slides.length > 0 ){
            this.slideview.source = new List<ISlide>( this.data.slides );
        }

        this.data.change.add( ( key, value ) => {
            if( this.data.modelName !== 'App\\Pause' && key == 'title' ) this.node.js( 'title' ).html = value;
        });

    }

    private onSelect( slide:ISlide ){
        this.selected.dispatch( slide );
    }


}

export default SlideSequence;